import { compose } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { storeActive as activeStoreSelector } from 'ggApp/modules/store/selectors';
import { userId as userIdSelector } from 'ggApp/modules/auth/selectors';
import { initDone as initDoneSelector } from 'ggApp/modules/init/selectors';

import { SitewideBanner, SitewideBannerProps, EnhancedProps } from './SitewideBanner';

const enhance = compose<SitewideBannerProps & EnhancedProps, {}>(
    connect(
        createStructuredSelector({
            activeStore: activeStoreSelector,
            userId: userIdSelector,
            initDone: initDoneSelector,
        }),
    ),
);

export default enhance(SitewideBanner);
